import ResetPassword from '../components/Authentication/ResetPassword';

export default function ResetPasswordPage() {
	return <ResetPassword />;
}
